import BottomNav from "../components/BottomNav";
import "../css/mainhome.css";
import "../css/FundsScreen.css";
import { useNavigate } from "react-router-dom";
import AppHeader from "../components/AppHeader";

/* React Icons */
import { FaHistory, FaCoins } from "react-icons/fa";
import { GiPokerHand } from "react-icons/gi";

export default function MyBidsScreen() {
  const navigate = useNavigate();
  const walletBalance = localStorage.getItem("walletBalance");

  const tiles = [
    {
      title: "BID HISTORY",
      icon: <FaHistory />,
      tone: "bid-history",
      onClick: () => navigate("/bid-history"),
    },
    {
      title: "KING STARLINE BID HISTORY",
      icon: <GiPokerHand />,
      tone: "starline-history",
      onClick: () => navigate("/starline-bid-history"),
    },
    {
      title: "KING JACKPOT BID HISTORY",
      icon: <FaCoins />,
      tone: "jackpot-history",
      onClick: () => navigate("/jackpot-bid-history"),
    },
  ];

  return (
    <div className="mainhome-screen-wrapper">
      <AppHeader
        title="My Bids"
        walletBalance={walletBalance}
        onBack={() => navigate(-1)}
        onWalletClick={() => navigate("/passbook")}
      />

      <div className="funds-grid square full-width">
        {tiles.map((t) => (
          <button
            key={t.title}
            className={`funds-tile custom-shadow tone-${t.tone}`}
            onClick={t.onClick}
            aria-label={t.title}
          >
            {/* ✅ FIX: direct render */}
            <div className="tile-icon-wrap">
              {t.icon}
            </div>

            <div className="tile-title">{t.title}</div>

            <span className="tile-accent" />
          </button>
        ))}
      </div>

      <BottomNav active="My Bids" />
    </div>
  );
}